declare namespace $ {

	type $mol_view__dom_name_shm_hitalama_map_widget_float_drawing_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__dom_name_space_shm_hitalama_map_widget_float_drawing_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name_space'] >
	>
	type $mol_view__attr_shm_hitalama_map_widget_float_drawing_3 = $mol_type_enforce<
		({ 
			'points': ReturnType< $shm_hitalama_map_widget_float_drawing['stroke_points'] >,
			'fill': string,
			'stroke': ReturnType< $shm_hitalama_map_widget_float_drawing['stroke_color'] >,
			'stroke-width': ReturnType< $shm_hitalama_map_widget_float_drawing['stroke_width'] >,
			'stroke-linecap': string,
			'stroke-linejoin': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__dom_name_shm_hitalama_map_widget_float_drawing_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__dom_name_space_shm_hitalama_map_widget_float_drawing_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name_space'] >
	>
	type $mol_view__attr_shm_hitalama_map_widget_float_drawing_6 = $mol_type_enforce<
		({ 
			'viewBox': ReturnType< $shm_hitalama_map_widget_float_drawing['view_box'] >,
			'preserveAspectRatio': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_shm_hitalama_map_widget_float_drawing_7 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_widget_float_drawing['content_pointerdown'] > ): ReturnType< $shm_hitalama_map_widget_float_drawing['content_pointerdown'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_drawing_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_drawing['stroke_views'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_color_pick__color_shm_hitalama_map_widget_float_drawing_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_drawing['line_color'] >
		,
		ReturnType< $shm_hitalama_color_pick['color'] >
	>
	type $shm_hitalama_color_pick__color_default_shm_hitalama_map_widget_float_drawing_10 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_color_pick['color_default'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_float_drawing_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_drawing['line_color'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $shm_hitalama_map_borderwidth__border_width_shm_hitalama_map_widget_float_drawing_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_drawing['line_width'] >
		,
		ReturnType< $shm_hitalama_map_borderwidth['border_width'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_drawing_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_map_widget_float_drawing_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_drawing_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	export class $shm_hitalama_map_widget_float_drawing extends $shm_hitalama_map_widget_float {
		view_box( ): string
		content_pointerdown( next?: any ): any
		stroke_points( id: any): string
		stroke_color( id: any): string
		stroke_width( id: any): string
		Stroke( id: any): $mol_view
		stroke_views( ): readonly(any)[]
		Svg( ): $mol_view
		line_color( next?: string ): string
		Line_color( ): $shm_hitalama_color_pick
		Line_color_hex( ): $mol_string
		line_width( next?: number ): number
		Line_width( ): $shm_hitalama_map_borderwidth
		Line_labeler( ): $mol_labeler
		Drawing_settings( ): $mol_list
		scrollable( ): boolean
		controls( ): readonly(any)[]
		settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=drawing.view.tree.d.ts.map